import request from '@/utils/request'
// import axios from 'axios'

// const baseurl = 'http://192.168.31.221:44375'
const baseurl = 'http://149.28.43.151:8002'// 美国服务器
// const baseurl = 'http://118.190.216.205:8011'

/** login */
export const userLogin = (data) => request.post(baseurl + '/api/Auth/login', data)

export const userInfo = (token) => request.get(baseurl + '/api/Auth/userInfo', {headers: { Authorization: 'Bearer ' + token }})

/** Summary Page */
/** Warning List */
export const getWarningList = (data) => request.post(baseurl + '/api/summary/warninglist', data)

/** Pannel */
// Summary Max Load
export const getMaxLoad = (data) => request.post(baseurl + '/api/summary2/getMaxWheelLoadValueTop', data)

// Summary Max Load
export const getMaxDeflection = (data) => request.post(baseurl + '/api/summary2/getMaxDeformationValueTop', data)

// Summary Max Stress
export const getMaxStress = (data) => request.post(baseurl + '/api/summary2/getMaxStressValueTop', data)

/** Box Plot */
// Summary WheelForce
export const getWheelForce = (data) => request.post(baseurl + '/api/summary/wheelforce', data)

// Summary VerticalDisplacement
export const getVerticalDisplacement = (data) => request.post(baseurl + '/api/summary/verticaldisp', data)

// Summary Maximum Tensile Stress
export const getMaximumTensileStress = (data) => request.post(baseurl + '/api/summary/maxtensilestress', data)

// Summary Maximum Shear Stress
export const getMaximumShearStress = (data) => request.post(baseurl + '/api/summary/maxshearstress', data)

// strain data
export const getRealTimeStrain = () => request.get(baseurl + '/api/wheelforce/chartData')

// StrainGague RealTime
export const getStrainGagueRealTime = (data) => request.post(baseurl + '/api/sensor/strainGagueRealTime', data)

// StrainGague History
export const getStrainGagueHistory = (data) => request.post(baseurl + '/api/sensor/strainGagueHistory', data)

// Wheel Force Chart
export const getWheelForceChart = (time) => request.get(baseurl + '/api/wheelforce/chart', {params: {time: time}})

// Wheel Force Chart Real Time
export const getWheelForceRealTime = () => request.get(baseurl + '/api/wheelforce/realTime')

// Wheel Force Chart History
export const getWheelForceHistory = (data) => request.post(baseurl + '/api/wheelforce/history', data)

// Wheel Force Statistics Table
export const getWheelForceStatistics = (data) => request.post(baseurl + '/api/wheelforce/statistics', data)

// Deformation Chart
export const getDeformationChart = (time, name) => request.get(baseurl + '/api/deformation/chart', {params: {time: time, name: name}})

// Deformation Chart Real Time
export const getDeformationRealTime = (data) => request.post(baseurl + '/api/deformation/realTime', data)

// Deformation Chart History
export const getDeformationHistory = (data) => request.post(baseurl + '/api/deformation/history', data)

// Deformation Statistics Table
export const getDeformationStatistics = (data) => request.post(baseurl + '/api/deformation/statistics', data)

export const getWheelLoadEchart1 = (startTime, endTime) => request.get('http://118.190.216.205:8011/api/summary2/getMaxWheelLoadValue', {params: {startTime: startTime, endTime: endTime}})

// strain data
export function getRealTimeStrainData () {
  return request({
    url: baseurl + '/api/wheelforce/chartData',
    method: 'get'
  })
}

// inspection pictures
export function getInspectionPics (params) {
  let bridgeId = params.bridgeId
  let time = params.time
  return request({
    url: baseurl + '/api/upload/imgList',
    method: 'get',
    params: {
      bridgeId: bridgeId,
      time: time
    }
  })
}

// 其他现场图片的时间序列
export const getInspectionPicTime = (id) => request.get(baseurl + '/api/upload/imgTimes', {params: {bridgeId: id}})

/* export function getInspectionPicTimes (params) {
  let bridgeId = params.bridgeId
  return request({
    url: baseurl + '/api/upload/imgTimes',
    method: 'get',
    params: {
      bridgeId: bridgeId
    }
  })
} */

// 上传
export const postInspectionPic = (data) => request.post(baseurl + '/api/upload/img', data)

/* export function postInspectionPics (data) {
  return request({
    url: baseurl + '/api/upload/img',
    method: 'post',
    data
  })
} */

// file
export function postInspectionFiles (data) {
  return request({
    url: baseurl + '/api/upload/file',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/all.js